<template>
  <div>
    <div class="page-header bordered">
      <h1>
        {{ action === 'edit' ? 'Update Staffer' : 'Create Staffer'}}
      </h1>
    </div>

    <form>
      <ShowErrors
        :errorMessages="errorMessages"
      />

      <h3 class="subheadline">Staffer Info</h3>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="first_name" class="required">First Name</label>
            <input type="text" v-model="staffer.first_name" name="first_name"
              class="form-control form-control-lg" v-validate="'required|min:3'"
              data-vv-as="First Name" />
            <span v-show="errors.has('first_name')" class="input-error">
              Please enter your first name.
            </span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="last_name" class="required">Last Name</label>
            <input type="text" v-model="staffer.last_name" name="last_name"
              class="form-control form-control-lg" v-validate="'required|min:3'"
              data-vv-as="Last Name" />
            <span v-show="errors.has('last_name')" class="input-error">
              Please enter your last name.
            </span>
          </div>
        </div>
      </div>

      <div class="form-group">
        <label for="email" class="required">Email</label>
        <input type="email" name="email" class="form-control form-control-lg"
              v-model="staffer.email" v-validate="'required|email'" data-vv-as="Email"
               ref="email">
        <span v-show="errors.has('email')" class="input-error">
          Please enter a valid email address.
        </span>
      </div>

      <div class="form-group">
        <label for="confirm_email" class="required">Confirm Email</label>
        <input type="email" name="emailConfirmation" v-validate="'required|confirmed:email'"
              v-model="staffer.confirm_email" data-vv-as="Email" class="form-control form-control-lg" />
        <span v-show="errors.has('emailConfirmation')" class="input-error">
          {{ errors.first('emailConfirmation') }}
        </span>
      </div>

      <br/>
      <hr/>

      <div class="form-group">
        <button type="button" class="btn btn-lg btn-primary" v-on:click="validate()">
          {{ action === 'edit' ? 'Update Staffer' : 'Create Staffer'}}
        </button>
        &nbsp;
        <button type="button" class="btn btn-lg btn-default" v-on:click="goBack()">
          Cancel
        </button>
      </div>

    </form>
  </div>
</template>

<script>
import ShowErrors from '../../common/ShowErrors'

export default {
  name: 'stafferForm',
  components: {
    ShowErrors
  },
  data: function () {
    return {
      action: this.$route.params.action,
      staffer: {
        first_name: '',
        last_name: '',
        email: '',
        confirm_email: ''
      },
      errorMessages: []
    }
  },
  created () {
    this.getStaffer()
  },
  methods: {
    getStaffer () {
      var self = this

      if (this.action === 'edit') {
        var loader = this.$loading.show()

        this.$http.get('staffers/' + this.$route.params.id).then(function (response) {
          self.staffer = response.data
          self.staffer['confirm_email'] = self.staffer['email']
        }).finally(function () {
          loader.hide()
        })
      } else {
        this.clearForm()
      }
    },
    validate () {
      var self = this

      this.$validator.validateAll().then((result) => {
        if (result) {
          self.save()
        }
      })
    },
    save () {
      var self = this
      this.errorMessages = []
      var loader = this.$loading.show()

      if (this.action === 'edit') {
        this.$http.put('staffers/' + this.staffer.id, { staffer: this.staffer }).then(function (response) {
          self.$router.push('/users/staffers')
        }).catch(function (error) {
          if (error) {
            self.$swal({
              title: 'Error editing staffer!',
              type: 'error'
            })

            self.errorMessages = error.response.data.message || error.response.data.error
          }
        }).finally(function () {
          loader.hide()
        })
      } else {
        this.$http.post('staffers', { staffer: this.staffer }).then(function (response) {
          self.$router.push('/users/staffers')
        }).catch(function (error) {
          if (error) {
            self.$swal({
              title: 'Error creating staffer!',
              type: 'error'
            })

            self.errorMessages = error.response.data.message || error.response.data.error
          }
        }).finally(function () {
          loader.hide()
        })
      }
    },
    clearForm () {
      this.staffer['id'] = ''
      this.staffer['email'] = ''
      this.staffer['first_name'] = ''
      this.staffer['last_name'] = ''
    },
    goBack () {
      this.$router.push('/users/staffers')
    }
  }
}
</script>
